import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import { defer } from 'react-router-dom'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in the Forgot Password loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in the Forgot Password loader'
  )
  return defer({
    data: Promise.all([]),
  })
}
